import { ComponentProps } from 'react';
import { BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import { flags } from '@treams/treams-icons';

import { tokens } from '../theme/tokens';

export type FlagProps = ComponentProps<typeof Flag>;

const Container = styled(Flex)<{ $size: string }>`
	width: ${(props) => props.$size};
	background: ${tokens.surface.secondary};
	border-radius: ${tokens.radius.xs}px;
	aspect-ratio: 3 / 2;
	flex-grow: 0;
	flex-shrink: 0;
	position: relative;
	overflow: hidden;

	svg {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
	}
`;

export function Flag(props: { languageID: keyof typeof flags } & BoxProps) {
	const { languageID, width = 16, ...rest } = props;
	const Component = flags[languageID];
	const size = typeof width === 'number' ? `${width}px` : width;

	return (
		<Container $size={size} {...rest}>
			{Component && <Component />}
		</Container>
	);
}
